// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3V_RK","info":"PatientInfo_info__2mcZG"};